export interface IPageSelectorProps {
    data?: any[];
    totalRows: number;
    recordsPerPage?: number;
    currentPageNum: number;
    disabled?: boolean;
    changePageOnApplyOnly?: boolean;
    onPageChange: (pageNum: number) => void;
}

export const PageConfig = {
    MIN_PAGE_TO_SHOW: 2,
    PAGES_TO_LEFT: 1,
    PAGES_TO_RIGHT: 1,
    MIN_PAGE_THRESHOLD: 4
};